<app-alert-rules-header
    [alertRules]="selectedRule"
    (filtersChanged)="onFilterChange($event)">
</app-alert-rules-header>

<div class="d-flex">
    <app-alert-rules-table
        (selectedRow)="onCheckChange()" 
        (tableLoaded)="onTableLoaded($event)" 
        [filters]="filters" 
        class="col-12">
    </app-alert-rules-table>
</div>